import { Link } from "react-router-dom";
import { Logo } from "./Logo";
import { Facebook, Instagram, Youtube } from "lucide-react";

export function Footer() {
  return (
    <footer className="bg-[#0a1420] text-slate-300 border-t border-slate-800" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-14">
        <div className="grid grid-cols-2 md:grid-cols-5 gap-8">
          <div className="col-span-2">
            <Logo />
            <p className="mt-4 text-sm text-slate-400 max-w-xs">The race calendar for runners and athletes in Malaysia &amp; Singapore.</p>
            <div className="flex gap-4 mt-5">
              <a href="https://facebook.com" target="_blank" rel="noreferrer" className="text-slate-400 hover:text-[#22d3ee]"><Facebook size={20} /></a>
              <a href="https://instagram.com" target="_blank" rel="noreferrer" className="text-slate-400 hover:text-[#22d3ee]"><Instagram size={20} /></a>
              <a href="https://youtube.com" target="_blank" rel="noreferrer" className="text-slate-400 hover:text-[#22d3ee]"><Youtube size={20} /></a>
            </div>
          </div>
          <div>
            <h4 className="font-display font-bold uppercase tracking-wide text-white text-sm mb-4">Quick Links</h4>
            <ul className="space-y-2 text-sm">
              <li><Link to="/races" className="hover:text-[#22d3ee]">Find Races</Link></li>
              <li><Link to="/calendar" className="hover:text-[#22d3ee]">Calendar</Link></li>
              <li><Link to="/for-organizers" className="hover:text-[#22d3ee]">For Organizers</Link></li>
              <li><Link to="/about" className="hover:text-[#22d3ee]">About</Link></li>
              <li><Link to="/contact" className="hover:text-[#22d3ee]">Contact</Link></li>
            </ul>
          </div>
          <div>
            <h4 className="font-display font-bold uppercase tracking-wide text-white text-sm mb-4">Popular Locations</h4>
            <ul className="space-y-2 text-sm">
              {["Kuala Lumpur", "Selangor", "Penang", "Johor"].map((s) => (
                <li key={s}><Link to={`/races?state=${encodeURIComponent(s)}`} className="hover:text-[#22d3ee]">{s}</Link></li>
              ))}
              <li><Link to="/races" className="hover:text-[#22d3ee]">All Locations</Link></li>
            </ul>
          </div>
          <div>
            <h4 className="font-display font-bold uppercase tracking-wide text-white text-sm mb-4">Legal</h4>
            <ul className="space-y-2 text-sm">
              <li><Link to="/terms" className="hover:text-[#22d3ee]">Terms &amp; Conditions</Link></li>
              <li><Link to="/privacy" className="hover:text-[#22d3ee]">Privacy Policy</Link></li>
            </ul>
          </div>
        </div>
        <div className="mt-12 pt-6 border-t border-slate-800 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-slate-500">© 2026 YourRaceFinder. All rights reserved.</p>
          <p className="font-script text-xl text-[#22d3ee]">Find Your Next Race</p>
        </div>
      </div>
    </footer>
  );
}
